module.exports = __webpack_public_path__ + "img/shot_tx19112502.9b29d103.jpg";